module.exports = __WEBPACK_EXTERNAL_MODULE__rocket_chat_memo__;